// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__pDuKI","PageContent":"Page_PageContent__MkgRs","PageContentNoPadding":"Page_PageContentNoPadding__F1W1b","PageFullWidth":"Page_PageFullWidth__4qwJw"};